import React, { useState } from 'react';
import { Card, Button, Badge, Form } from 'react-bootstrap';
import { FaPlus, FaUser, FaUsers } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  marcarPresencaCheckinEventoRsvp,
  marcarAcompanhanteCheckinEventoRsvp,
} from '~/Services/Service';
import ModalAdicionarAcompanhante from './ModalAdicionarAcompanhante';

const extrairMensagemErro = (err, fallback) => {
  if (err && err.message) return err.message;
  if (typeof err === 'string') return err;
  return fallback;
};

const formatarCpf = (cpf) => {
  if (!cpf) return '';
  const so = String(cpf).replace(/\D/g, '').padStart(11, '0');
  return `${so.substr(0, 3)}.${so.substr(3, 3)}.${so.substr(6, 3)}-${so.substr(9, 2)}`;
};

const formatarTelefone = (tel) => {
  if (!tel) return '';
  const d = String(tel).replace(/\D/g, '');
  if (d.length === 11) {
    return `(${d.substr(0, 2)}) ${d.substr(2, 5)}-${d.substr(7, 4)}`;
  }
  if (d.length === 10) {
    return `(${d.substr(0, 2)}) ${d.substr(2, 4)}-${d.substr(6, 4)}`;
  }
  return tel;
};

const LinhaCheck = ({
  label,
  sublabel,
  marcado,
  dataEntrada,
  salvando,
  onToggle,
  icone,
}) => (
  <div
    className="d-flex align-items-center justify-content-between py-2 px-2 rounded"
    style={{
      background: marcado ? 'rgba(40, 167, 69, 0.08)' : 'transparent',
      borderLeft: marcado ? '3px solid #28a745' : '3px solid transparent',
      minHeight: 56,
    }}
  >
    <div className="d-flex align-items-center" style={{ flex: 1, minWidth: 0 }}>
      <span className="mr-2 text-muted">{icone}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 500, fontSize: '0.95rem' }}>{label}</div>
        {sublabel && (
          <div className="text-muted" style={{ fontSize: '0.8rem' }}>
            {sublabel}
          </div>
        )}
        {marcado && dataEntrada && (
          <div className="text-success" style={{ fontSize: '0.75rem' }}>
            Entrada em {moment(dataEntrada).format('DD/MM HH:mm')}
          </div>
        )}
      </div>
    </div>
    <Form.Check
      type="switch"
      id={`switch-${label}-${Math.random()}`}
      checked={marcado}
      disabled={salvando}
      onChange={onToggle}
      style={{ marginRight: 8 }}
    />
  </div>
);

const CardConfirmado = ({ confirmado, onAtualizar, onPromoverProspecto }) => {
  const [salvandoPresenca, setSalvandoPresenca] = useState({});
  const [salvandoAcomp, setSalvandoAcomp] = useState({});
  const [showAdicionar, setShowAdicionar] = useState(false);

  const togglePresenca = async (presenca) => {
    const id = presenca.codigo;
    const novoValor = !presenca.presenca_entrada;
    setSalvandoPresenca((s) => ({ ...s, [id]: true }));
    onAtualizar({
      ...confirmado,
      presencas: confirmado.presencas.map((p) =>
        p.codigo === id ? { ...p, presenca_entrada: novoValor } : p
      ),
    });
    try {
      const res = await marcarPresencaCheckinEventoRsvp({
        codigo_presenca: id,
        entrada: novoValor,
      });
      onAtualizar({
        ...confirmado,
        presencas: confirmado.presencas.map((p) =>
          p.codigo === id
            ? { ...p, presenca_entrada: novoValor, data_entrada: res ? res.data_entrada : null }
            : p
        ),
      });
    } catch (err) {
      onAtualizar({
        ...confirmado,
        presencas: confirmado.presencas.map((p) =>
          p.codigo === id ? { ...p, presenca_entrada: !novoValor } : p
        ),
      });
      toast.error(extrairMensagemErro(err, 'Erro ao registrar entrada.'));
    } finally {
      setSalvandoPresenca((s) => ({ ...s, [id]: false }));
    }
  };

  const toggleAcompanhante = async (acomp) => {
    const id = acomp.codigo;
    const novoValor = !acomp.presenca_entrada;
    setSalvandoAcomp((s) => ({ ...s, [id]: true }));
    onAtualizar({
      ...confirmado,
      acompanhantes: confirmado.acompanhantes.map((a) =>
        a.codigo === id ? { ...a, presenca_entrada: novoValor } : a
      ),
    });
    try {
      const res = await marcarAcompanhanteCheckinEventoRsvp({
        codigo_acompanhante: id,
        entrada: novoValor,
      });
      onAtualizar({
        ...confirmado,
        acompanhantes: confirmado.acompanhantes.map((a) =>
          a.codigo === id
            ? { ...a, presenca_entrada: novoValor, data_entrada: res ? res.data_entrada : null }
            : a
        ),
      });
    } catch (err) {
      onAtualizar({
        ...confirmado,
        acompanhantes: confirmado.acompanhantes.map((a) =>
          a.codigo === id ? { ...a, presenca_entrada: !novoValor } : a
        ),
      });
      toast.error(extrairMensagemErro(err, 'Erro ao registrar entrada.'));
    } finally {
      setSalvandoAcomp((s) => ({ ...s, [id]: false }));
    }
  };

  const onAcompanhanteCriado = (novo) => {
    setShowAdicionar(false);
    onAtualizar({
      ...confirmado,
      acompanhantes: [...(confirmado.acompanhantes || []), novo],
    });
  };

  const totalPresentes =
    (confirmado.presencas || []).filter((p) => p.presenca_entrada).length +
    (confirmado.acompanhantes || []).filter((a) => a.presenca_entrada).length;
  const totalEsperado =
    (confirmado.presencas || []).filter((p) => p.confirma_presenca).length +
    (confirmado.acompanhantes || []).length;

  return (
    <>
      <Card className="mb-3">
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: '1.05rem' }}>
                {confirmado.nome_cliente}
              </div>
              <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                CPF {formatarCpf(confirmado.cpf_cliente)}
                {confirmado.telefone ? ` · ${formatarTelefone(confirmado.telefone)}` : ''}
              </div>
              {confirmado.quadras_lotes && (
                <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                  Quadras/Lotes: {confirmado.quadras_lotes}
                </div>
              )}
            </div>
            <Badge
              variant={totalPresentes > 0 ? 'success' : 'secondary'}
              style={{ fontSize: '0.85rem' }}
            >
              {totalPresentes}/{totalEsperado}
            </Badge>
          </div>

          <hr className="my-2" />

          <div className="mb-2">
            <small className="text-muted font-weight-bold">PRESENÇAS</small>
            {(confirmado.presencas || []).length === 0 ? (
              <p className="text-muted small mb-0">Nenhuma presença registrada.</p>
            ) : (
              (confirmado.presencas || []).map((p) => (
                <LinhaCheck
                  key={`p-${p.codigo}`}
                  icone={<FaUser />}
                  label={p.nome_titular}
                  sublabel={
                    <>
                      {formatarCpf(p.cpf_titular)}
                      {!p.confirma_presenca && (
                        <Badge variant="warning" className="ml-2">
                          Disse "não vai"
                        </Badge>
                      )}
                    </>
                  }
                  marcado={p.presenca_entrada}
                  dataEntrada={p.data_entrada}
                  salvando={salvandoPresenca[p.codigo]}
                  onToggle={() => togglePresenca(p)}
                />
              ))
            )}
          </div>

          <div>
            <div className="d-flex justify-content-between align-items-center">
              <small className="text-muted font-weight-bold">ACOMPANHANTES</small>
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() => setShowAdicionar(true)}
              >
                <FaPlus className="mr-1" /> Adicionar
              </Button>
            </div>
            {(confirmado.acompanhantes || []).length === 0 ? (
              <p className="text-muted small mb-0 mt-1">Nenhum acompanhante.</p>
            ) : (
              (confirmado.acompanhantes || []).map((a) => (
                <LinhaCheck
                  key={`a-${a.codigo}`}
                  icone={<FaUsers />}
                  label={a.nome}
                  sublabel={`${formatarTelefone(a.telefone)} · ${a.idade} anos`}
                  marcado={a.presenca_entrada}
                  dataEntrada={a.data_entrada}
                  salvando={salvandoAcomp[a.codigo]}
                  onToggle={() => toggleAcompanhante(a)}
                />
              ))
            )}
          </div>
        </Card.Body>
      </Card>

      {showAdicionar && (
        <ModalAdicionarAcompanhante
          show
          onHide={() => setShowAdicionar(false)}
          codigoConfirmacao={confirmado.codigo_confirmacao}
          nomeCliente={confirmado.nome_cliente}
          onCriado={onAcompanhanteCriado}
          onPromoverProspecto={(codigoProspecto) => {
            setShowAdicionar(false);
            if (onPromoverProspecto) onPromoverProspecto(codigoProspecto);
          }}
        />
      )}
    </>
  );
};

export default CardConfirmado;
